import { dropBoolean } from 'utils/drops';

const getTipoVinculoFilterFields = () => [
  { name: 'id', label: 'ID', type: 'number' },
  { name: 'descricao', label: 'Descrição', initial: true },
  { name: 'codigo', label: 'Código', type: 'number' },
  { name: 'selecao', label: 'Seleção', type: 'select', options: dropBoolean },
];

export default getTipoVinculoFilterFields;
